import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ForgotPassword, Login, OtpVerification, Registration, SetPassword } from "../Auth";

function AuthRoute() {
  return (
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/reset-password" element={<ForgotPassword />} />
        <Route path="/set-new-password/:token/:email" element={<SetPassword />} />
        <Route path="/otp-verification/:email/:otp_type" element={<OtpVerification />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AuthRoute;
